<template>
	<div class="betslip__bet__group" width="100%">
		<div class="betslip__bet__group__top">
			<div class="betslip__bet__group__top__title">
				{{ home_team | toTitleCase }} vs {{ away_team | toTitleCase }}
			</div>
			<button class="betslip__bet__group__top__remove" @click="removeMatch">
				&times;
			</button>
		</div>
		<div class="betslip__bet" v-for="(pick, i) in picks" :key="i">
			<button class="betslip__bet__remove" @click="removePick(pick)">
				&times;
			</button>
			<div class="betslip__bet__details">
				<div class="betslip__bet__row betslip__bet__row--top">
					{{ pick.market | toTitleCase }} •
					{{ pick.odd_key | toTitleCase }}
					<span v-if="pick.special_bet_value"
						>({{ pick.special_bet_value }})</span
					>
				</div>
			</div>

			<div class="betslip__bet__row betslip__bet__row--middle">
				<span class="odd-value bold">
					{{ pick.odd_value }}
				</span>
			</div>
		</div>

		<div class="betslip__bet__group__bottom">
			<span class="betslip__bet__marker betslip__bet__marker--starttime">
				<span>Starts {{ picks[0].startTime | time }}</span>
			</span>
			<span class="betslip__bet__total-odd">
				<b>{{ total_odd }}</b>
			</span>
		</div>
	</div>
</template>

<script>
export default {
	name: "bet",
	props: ["bet"],
	methods: {
		removeMatch() {
			this.$store.commit("removeFromJengabetBetslip", this.bet.bet[0]);
		},
		removePick(pick) {
			this.$store.commit("removeMarketFromJengabetBetslip", pick);
		},
	},
	computed: {
		picks() {
			return this.bet.bet;
		},
		home_team() {
			return this.bet.bet[0].home_team;
		},
		away_team() {
			return this.bet.bet[0].away_team;
		},
		total_odd() {
			let total_odd = this.bet.bet.reduce((a, b) => a * b.odd_value, 1);
			return Math.round(total_odd * 100) / 100;
		},
	},
};
</script>
